module.exports = __webpack_public_path__ + "portal-static/img/cb.8853931d.png";